export const LocalStorageKeys = {
  ShowMyRequestOnly: "RFX_SHOW_MY_REQUEST_ONLY",
  RFXRequestTable: 'RFX_REQUEST_TABLE',
  RFXServerSideTablePreference: 'RFX_SERVER_SIDE_TABLE_PREFERENCE',
  RFXServerSideTableFiltering: 'RFX_SERVER_SIDE_TABLE_FILTERING',
  RFXServerSideTableWidths: 'RFX_SERVER_SIDE_TABLE_WIDTHS',
  RFXServerSideTableSortingState: 'RFX_SERVER_SIDE_TABLE_SORTING_STATE',
  ChangeOrderTableWidths: 'CHANGE_ORDER_TABLE_WIDTHS',
  ChangeOrderTablePreference: 'QUOTE_CHANGE_ORDER_TABLE_PREFERENCE'
}

export const DebounceOptions = {
  waitTimeInMs: 300,
  options: {leading: true}
}

export const ErrorName = {
  unhandledRejection: 'UnhandledRejection'
}